// Croatian public holidays. Iter50: dinamički — popis dolazi iz /api/vacation/info
// (bazni 2026 + admin-dodani extras kroz Postavke). NewRequest.jsx zove setHolidays()
// čim info učita, pa svi kalendari odmah reflektiraju nove praznike.

// Bazni 2026 fallback (prije nego što /api/vacation/info učita).
const DEFAULT_HOLIDAYS = [
  ["2026-01-01", "Nova godina"],
  ["2026-01-06", "Sveta tri kralja"],
  ["2026-04-05", "Uskrs"],
  ["2026-04-06", "Uskrsni ponedjeljak"],
  ["2026-05-01", "Praznik rada"],
  ["2026-05-30", "Dan državnosti"],
  ["2026-06-04", "Tijelovo"],
  ["2026-06-22", "Dan antifašističke borbe"],
  ["2026-08-05", "Dan pobjede"],
  ["2026-08-15", "Velika Gospa"],
  ["2026-11-01", "Svi sveti"],
  ["2026-11-18", "Dan sjećanja"],
  ["2026-12-25", "Božić"],
  ["2026-12-26", "Sveti Stjepan"],
];

let _HOLIDAYS = DEFAULT_HOLIDAYS.slice();
let _HOLIDAY_SET = new Set(_HOLIDAYS.map(h => h[0]));

export function setHolidays(list) {
  if (!Array.isArray(list) || list.length === 0) return;
  _HOLIDAYS = list.map(h => Array.isArray(h) ? [h[0], h[1]] : [h?.date, h?.name]).filter(h => h[0]);
  _HOLIDAY_SET = new Set(_HOLIDAYS.map(h => h[0]));
}

export function getHolidays() {
  return _HOLIDAYS.slice();
}

// Backwards-compat export (legacy code reads this; refleksija trenutnog stanja)
export const HOLIDAYS = _HOLIDAYS;

export function isHoliday(d) {
  if (!d) return false;
  const iso = d instanceof Date
    ? `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`
    : d;
  return _HOLIDAY_SET.has(iso);
}

// Iter49: kolektivno razdoblje je konfigurabilno u Postavkama.
let _collectiveStart = "2026-07-27";
let _collectiveEnd = "2026-08-14";

export function setCollectivePeriod(startIso, endIso) {
  if (startIso) _collectiveStart = startIso;
  if (endIso) _collectiveEnd = endIso;
}

export function getCollectivePeriod() {
  return { start: _collectiveStart, end: _collectiveEnd };
}

export const COLLECTIVE_START_ISO = _collectiveStart;
export const COLLECTIVE_END_ISO = _collectiveEnd;

export function isCollectiveDay(d) {
  if (!d) return false;
  const iso = d instanceof Date
    ? `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`
    : d;
  return iso >= _collectiveStart && iso <= _collectiveEnd;
}

export function holidayName(d) {
  const iso = d instanceof Date
    ? `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`
    : d;
  return _HOLIDAYS.find(h => h[0] === iso)?.[1];
}
